export const cardStyles = {
  border: "none",
  position: "relative",
  display: "flex",
  flexDirection: "column",
};

export const imageContainerStyles = {
  width: "auto",
  height: { xs: 241, sm: 353 },
  overflow: "hidden",
  bgcolor: "#F7F8FA",
  border: "1px solid #E4E5E9",
  boxSizing: "border-box",
  borderRadius: "20px",
  p: 1,
};

export const imageStyles = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
};
